import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";

var isValidValue = function isValidValue(x) {
  return x != null && !Number.isNaN(x) && typeof x !== 'boolean';
};

var removeNonPrintingValuesTransformer = function removeNonPrintingValuesTransformer() {
  return {
    onSubstitution: function onSubstitution(substitution) {
      if (Array.isArray(substitution)) {
        return substitution.filter(isValidValue);
      }

      if (isValidValue(substitution)) {
        return substitution;
      }

      return '';
    }
  };
};

export default removeNonPrintingValuesTransformer;